<header id="page-topbar" [class.hidden]="isHidden" (mouseenter)="showTopbar()" (mouseleave)="scheduleHideTopbar()">
  <div class="navbar-header">
    <div class="d-flex align-items-center">
      <!-- Menu Button -->
      <button type="button" class="btn btn-sm px-3 font-size-24 header-item waves-effect" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="ri-menu-2-line align-middle"></i>
      </button>
    </div>

    <div class="d-flex align-items-center">
      <!-- Bell Icon: Always visible -->
      <div class="dropdown d-inline-block ms-1" *ngIf="showNotificationBell()">
        <button (click)="triggerPush()" class="btn header-item waves-effect noti-icon">
          <i class="mdi mdi-bell font-size-20 align-middle"></i>
        </button>
      </div>     

      <!-- Fullscreen Button -->
      <div class="dropdown d-inline-block ms-1">
        <button type="button" class="btn header-item waves-effect noti-icon" (click)="fullscreen()">
          <i class="ri-fullscreen-line"></i>
        </button>
      </div>

      <!-- User Dropdown -->
      <div class="dropdown d-inline-block user-dropdown" ngbDropdown>
        <button type="button" ngbDropdownToggle class="btn header-item waves-effect" id="page-header-user-dropdown">
          <span class="ms-1 me-2 welcome-copy">Welcome, {{ welcomeName }}</span>
          <i class="mdi mdi-account-circle font-size-20 align-middle"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript:void(0);" (click)="logout()">
            <i class="ri-shut-down-line align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</header>